import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "dt-element__wrapper"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "swiper-wrapper" }
const _hoisted_6 = { class: "swiper-slide" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }, null, -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "dt-element__title"
}
const _hoisted_13 = {
  key: 1,
  class: "dt-element__title"
}
const _hoisted_14 = {
  key: 4,
  class: "dt-element__wrapper dt-element__tagList"
}
const _hoisted_15 = {
  key: 0,
  class: "dt-element__tag"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "dt-element__tag-bg" }, null, -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "dt-element__tag-bg" }, null, -1 /* HOISTED */)
const _hoisted_19 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<rect y=\"2\" width=\"12\" height=\"2\" rx=\"1\"></rect><rect y=\"7\" width=\"12\" height=\"2\" rx=\"1\"></rect><rect y=\"12\" width=\"12\" height=\"2\" rx=\"1\"></rect><rect x=\"14\" y=\"2\" width=\"2\" height=\"2\" rx=\"1\"></rect><rect x=\"14\" y=\"7\" width=\"2\" height=\"2\" rx=\"1\"></rect><rect x=\"14\" y=\"12\" width=\"2\" height=\"2\" rx=\"1\"></rect>", 6)
const _hoisted_26 = [
  _hoisted_20
]
const _hoisted_27 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.0803 8.90916C12.7774 7.688 13 6.94194 13 6.66667C13 5.68803 12.5229 4.48823 11.626 3.51561C10.7412 2.55625 9.61969 2 8.5 2C7.38031 2 6.25878 2.55625 5.37404 3.51561C4.47706 4.48823 4 5.68803 4 6.66667C4 6.94194 4.22263 7.688 4.91968 8.90916C5.55791 10.0273 6.41872 11.2502 7.27164 12.3673C7.89297 13.1811 8.23147 13.6143 8.5 13.8754C8.76853 13.6143 9.10703 13.1811 9.72836 12.3673C10.5813 11.2502 11.4421 10.0273 12.0803 8.90916ZM11.318 13.581C13.0734 11.2819 15 8.37051 15 6.66667C15 3.53705 12.0899 0 8.5 0C4.91015 0 2 3.53705 2 6.66667C2 8.37051 3.9266 11.2819 5.68202 13.581C6.90116 15.1777 7.51073 15.9761 8.5 15.9761C9.48927 15.9761 10.0988 15.1777 11.318 13.581Z"
}, null, -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", { d: "M9.99991 6.5C9.99991 7.32843 9.32834 8 8.49991 8C7.67149 8 6.99991 7.32843 6.99991 6.5C6.99991 5.67157 7.67149 5 8.49991 5C9.32834 5 9.99991 5.67157 9.99991 6.5Z" }, null, -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("path", { d: "M8.36622 7C8.19331 6.7011 7.87014 6.5 7.5 6.5C6.94772 6.5 6.5 6.94772 6.5 7.5V10.5C6.5 11.0523 6.94772 11.5 7.5 11.5C8.05228 11.5 8.5 11.0523 8.5 10.5V9H11C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7H8.36622Z" }, null, -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0Z"
}, null, -1 /* HOISTED */)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 3,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("path", { d: "M1 8C1 7.44772 1.44772 7 2 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H2C1.44772 9 1 8.55228 1 8Z" }, null, -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("path", { d: "M3 0C3.55228 2.41411e-08 4 0.447715 4 1L4 3C4 3.55228 3.55228 4 3 4C2.44772 4 2 3.55228 2 3L2 1C2 0.447715 2.44772 -2.41411e-08 3 0Z" }, null, -1 /* HOISTED */)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("path", { d: "M13 0C13.5523 2.41411e-08 14 0.447715 14 1V3C14 3.55228 13.5523 4 13 4C12.4477 4 12 3.55228 12 3V1C12 0.447715 12.4477 -2.41411e-08 13 0Z" }, null, -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 5H4C3.00065 5 2.45234 5.00425 2.07195 5.05539C2.067 5.05606 2.06214 5.05672 2.05739 5.05739C2.05672 5.06214 2.05606 5.06699 2.05539 5.07195C2.00425 5.45234 2 6.00065 2 7V12C2 12.9993 2.00425 13.5477 2.05539 13.928C2.05606 13.933 2.05672 13.9379 2.05739 13.9426C2.06214 13.9433 2.067 13.9439 2.07195 13.9446C2.45234 13.9958 3.00065 14 4 14H12C12.9993 14 13.5477 13.9958 13.928 13.9446C13.933 13.9439 13.9379 13.9433 13.9426 13.9426C13.9433 13.9379 13.9439 13.933 13.9446 13.928C13.9958 13.5477 14 12.9993 14 12V7C14 6.00065 13.9958 5.45234 13.9446 5.07195C13.9439 5.06699 13.9433 5.06214 13.9426 5.05739C13.9379 5.05672 13.933 5.05606 13.928 5.05539C13.5477 5.00425 12.9993 5 12 5ZM14.1381 5.09681C14.1381 5.09682 14.1375 5.0966 14.1363 5.09614L14.1381 5.09681ZM13.9039 4.86369C13.9034 4.86251 13.9032 4.86189 13.9032 4.86187L13.9039 4.86369ZM13.9032 14.1381C13.9032 14.1381 13.9034 14.1375 13.9039 14.1363L13.9032 14.1381ZM2.09681 14.1381C2.0968 14.1381 2.09657 14.1376 2.09614 14.1363L2.09681 14.1381ZM1.86187 5.09681C1.86186 5.0968 1.86244 5.09657 1.86368 5.09614L1.86187 5.09681ZM0.585786 3.58579C0 4.17157 0 5.11438 0 7V12C0 13.8856 0 14.8284 0.585786 15.4142C1.17157 16 2.11438 16 4 16H12C13.8856 16 14.8284 16 15.4142 15.4142C16 14.8284 16 13.8856 16 12V7C16 5.11438 16 4.17157 15.4142 3.58579C14.8284 3 13.8856 3 12 3H4C2.11438 3 1.17157 3 0.585786 3.58579Z"
}, null, -1 /* HOISTED */)
const _hoisted_40 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = {
  key: 4,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11 2H5C4.00065 2 3.45234 2.00425 3.07195 2.05539C3.067 2.05606 3.06214 2.05672 3.05739 2.05739C3.05672 2.06214 3.05606 2.067 3.05539 2.07195C3.00425 2.45234 3 3.00065 3 4V12C3 12.9993 3.00425 13.5477 3.05539 13.928C3.05606 13.933 3.05672 13.9379 3.05739 13.9426C3.06214 13.9433 3.067 13.9439 3.07195 13.9446C3.45234 13.9958 4.00065 14 5 14H11C11.9993 14 12.5477 13.9958 12.928 13.9446C12.933 13.9439 12.9379 13.9433 12.9426 13.9426C12.9433 13.9379 12.9439 13.933 12.9446 13.928C12.9958 13.5477 13 12.9993 13 12V4C13 3.00065 12.9958 2.45234 12.9446 2.07195C12.9439 2.067 12.9433 2.06214 12.9426 2.05739C12.9379 2.05672 12.933 2.05606 12.928 2.05539C12.5477 2.00425 11.9993 2 11 2ZM13.1381 2.09681L13.1363 2.09614L13.1381 2.09681ZM12.9039 1.8637L12.9032 1.86187L12.9039 1.8637ZM12.9032 14.1381L12.9039 14.1363L12.9032 14.1381ZM2.86187 2.09681L2.86368 2.09614L2.86187 2.09681ZM1.58579 0.585786C1 1.17157 1 2.11438 1 4V12C1 13.8856 1 14.8284 1.58579 15.4142C2.17157 16 3.11438 16 5 16H11C12.8856 16 13.8284 16 14.4142 15.4142C15 14.8284 15 13.8856 15 12V4C15 2.11438 15 1.17157 14.4142 0.585786C13.8284 0 12.8856 0 11 0H5C3.11438 0 2.17157 0 1.58579 0.585786Z"
}, null, -1 /* HOISTED */)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("path", { d: "M4 5H12V7H4V5Z" }, null, -1 /* HOISTED */)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("path", { d: "M4 9H12V11H4V9Z" }, null, -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_42,
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = {
  key: 5,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.5 2C7.39543 2 6.5 2.89543 6.5 4C6.5 5.10457 7.39543 6 8.5 6C9.60457 6 10.5 5.10457 10.5 4C10.5 2.89543 9.60457 2 8.5 2ZM4.5 4C4.5 1.79086 6.29086 0 8.5 0C10.7091 0 12.5 1.79086 12.5 4C12.5 6.20914 10.7091 8 8.5 8C6.29086 8 4.5 6.20914 4.5 4Z"
}, null, -1 /* HOISTED */)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 13.7C1 9.55786 4.35786 6.2 8.5 6.2C12.6421 6.2 16 9.55786 16 13.7V14.5125C16 15.334 15.334 16 14.5125 16H2.4875C1.66598 16 1 15.334 1 14.5125V13.7ZM8.5 8.2C5.46243 8.2 3 10.6624 3 13.7V14H14V13.7C14 10.6624 11.5376 8.2 8.5 8.2Z"
}, null, -1 /* HOISTED */)
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = {
  key: 6,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.07948 5.73252C6.06757 5.75054 6.05002 5.76376 6.02981 5.76994L2.89946 6.72669C2.83771 6.74556 2.81349 6.82284 2.85275 6.87575L4.84286 9.5575C4.85571 9.57482 4.86241 9.5962 4.86183 9.61805L4.77211 13.0005C4.77034 13.0672 4.83375 13.115 4.89441 13.0926L7.9693 11.9589C7.98916 11.9516 8.01084 11.9516 8.0307 11.9589L11.1056 13.0926C11.1663 13.115 11.2297 13.0672 11.2279 13.0005L11.1382 9.61805C11.1376 9.5962 11.1443 9.57482 11.1571 9.5575L13.1473 6.87575C13.1865 6.82284 13.1623 6.74556 13.1005 6.72669L9.97019 5.76994C9.94998 5.76376 9.93243 5.75054 9.92052 5.73252L8.07558 2.9414C8.03919 2.88634 7.96081 2.88634 7.92442 2.9414L6.07948 5.73252ZM11.0822 4.12887L13.6187 4.90412C14.9156 5.30048 15.4242 6.92344 14.5997 8.03444L12.9871 10.2075L13.0598 12.9482C13.097 14.3495 11.7655 15.3525 10.4916 14.8829L8 13.9642L5.50842 14.8829C4.23455 15.3525 2.90301 14.3495 2.94018 12.9482L3.01288 10.2075L1.4003 8.03444C0.575832 6.92344 1.08443 5.30048 2.38128 4.90412L4.91779 4.12887L6.41274 1.86723C7.17706 0.710923 8.82293 0.710921 9.58726 1.86723L11.0822 4.12887Z"
}, null, -1 /* HOISTED */)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 0,
  class: "dt-element__listContact-title"
}
const _hoisted_54 = { class: "dt-element__listContact-list" }
const _hoisted_55 = {
  key: 8,
  class: "dt-element__wrapper dt-element__dateTime"
}
const _hoisted_56 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("path", { d: "M1 8C1 7.44772 1.44772 7 2 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H2C1.44772 9 1 8.55228 1 8Z" }, null, -1 /* HOISTED */)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("path", { d: "M3 0C3.55228 2.41411e-08 4 0.447715 4 1L4 3C4 3.55228 3.55228 4 3 4C2.44772 4 2 3.55228 2 3L2 1C2 0.447715 2.44772 -2.41411e-08 3 0Z" }, null, -1 /* HOISTED */)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("path", { d: "M13 0C13.5523 2.41411e-08 14 0.447715 14 1V3C14 3.55228 13.5523 4 13 4C12.4477 4 12 3.55228 12 3V1C12 0.447715 12.4477 -2.41411e-08 13 0Z" }, null, -1 /* HOISTED */)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 5H4C3.00065 5 2.45234 5.00425 2.07195 5.05539C2.067 5.05606 2.06214 5.05672 2.05739 5.05739C2.05672 5.06214 2.05606 5.06699 2.05539 5.07195C2.00425 5.45234 2 6.00065 2 7V12C2 12.9993 2.00425 13.5477 2.05539 13.928C2.05606 13.933 2.05672 13.9379 2.05739 13.9426C2.06214 13.9433 2.067 13.9439 2.07195 13.9446C2.45234 13.9958 3.00065 14 4 14H12C12.9993 14 13.5477 13.9958 13.928 13.9446C13.933 13.9439 13.9379 13.9433 13.9426 13.9426C13.9433 13.9379 13.9439 13.933 13.9446 13.928C13.9958 13.5477 14 12.9993 14 12V7C14 6.00065 13.9958 5.45234 13.9446 5.07195C13.9439 5.06699 13.9433 5.06214 13.9426 5.05739C13.9379 5.05672 13.933 5.05606 13.928 5.05539C13.5477 5.00425 12.9993 5 12 5ZM14.1381 5.09681C14.1381 5.09682 14.1375 5.0966 14.1363 5.09614L14.1381 5.09681ZM13.9039 4.86369C13.9034 4.86251 13.9032 4.86189 13.9032 4.86187L13.9039 4.86369ZM13.9032 14.1381C13.9032 14.1381 13.9034 14.1375 13.9039 14.1363L13.9032 14.1381ZM2.09681 14.1381C2.0968 14.1381 2.09657 14.1376 2.09614 14.1363L2.09681 14.1381ZM1.86187 5.09681C1.86186 5.0968 1.86244 5.09657 1.86368 5.09614L1.86187 5.09681ZM0.585786 3.58579C0 4.17157 0 5.11438 0 7V12C0 13.8856 0 14.8284 0.585786 15.4142C1.17157 16 2.11438 16 4 16H12C13.8856 16 14.8284 16 15.4142 15.4142C16 14.8284 16 13.8856 16 12V7C16 5.11438 16 4.17157 15.4142 3.58579C14.8284 3 13.8856 3 12 3H4C2.11438 3 1.17157 3 0.585786 3.58579Z"
}, null, -1 /* HOISTED */)
const _hoisted_61 = [
  _hoisted_57,
  _hoisted_58,
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = { class: "block-textMin gray" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("template", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_contact_short_block = _resolveComponent("icon-contact-short-block")!
  const _component_map_element = _resolveComponent("map-element")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.element['@type'] === 'image')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: $props.element.value?.url || this.emptyImagePreview(),
          "data-fancybox": "",
          class: _normalizeClass(["dt-element__image", {
            'square': $props.element.style.viewMode === 'square',
            'rectangle': $props.element.style.viewMode === 'rectangle',
            'disableBg': !$props.element.useWhiteBackground}])
        }, [
          _createElementVNode("img", {
            src: $props.element.value?.url || this.emptyImagePreview()
          }, null, 8 /* PROPS */, _hoisted_2)
        ], 10 /* CLASS, PROPS */, _hoisted_1))
      : ($props.element['@type'] === 'button')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($props.element['@type'] == 'button' || $props.element['@type'] == 'undefined')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  ($props.element['action']['@type'] === 'open-card')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: $options.getUrl(),
                        class: _normalizeClass($options.getClassesBtn($props.element))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($props.element.title), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["to", "class"]))
                    : _createCommentVNode("v-if", true),
                  ($props.element['action']['@type'] === 'link')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: $props.element['action']['value'],
                        target: "_blank",
                        class: _normalizeClass($options.getClassesBtn($props.element))
                      }, _toDisplayString($props.element.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
                    : _createCommentVNode("v-if", true),
                  ($props.element['action']['@type'] === 'script')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.executeScript($props.element['action']['script']))),
                        class: _normalizeClass($options.getClassesBtn($props.element))
                      }, _toDisplayString($props.element.title), 3 /* TEXT, CLASS */))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : ($props.element['@type'] === 'gallery')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["dt-element__wrapper js-swiper-gallery dt-element__gallery", {
                                                                    'square': $props.element.style.viewMode === 'square',
                                                                    'rectangle': $props.element.style.viewMode === 'rectangle',
                                                                    'disableBg': !$props.element.useWhiteBackground
                                                                    }])
            }, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.element.value, (image) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("a", {
                      href: image.url,
                      class: "dt-element__gallery-item",
                      "data-fancybox": "gallery"
                    }, [
                      _createElementVNode("img", {
                        src: image.url
                      }, null, 8 /* PROPS */, _hoisted_8)
                    ], 8 /* PROPS */, _hoisted_7)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              _hoisted_9,
              _hoisted_10,
              _hoisted_11
            ], 2 /* CLASS */))
          : ($props.element['@type'] === 'title')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                ($options.checkIsFirstTitleElement())
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_12, _toDisplayString($props.element.value), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($props.element.value), 1 /* TEXT */))
              ], 64 /* STABLE_FRAGMENT */))
            : ($props.element['@type'] === 'tags')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.element.tags, (tag) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (tag['@type'] === 'tag')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            ($props.element.useRefForFilter === true)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => ($options.onApplyFilterByTag(tag)),
                                  style: _normalizeStyle({
                                color: $props.element.defaultColor !== true && tag.color !== null ? tag.color : null,
                            }),
                                  class: _normalizeClass({
                                'square': $props.element.style.viewMode === 'square',
                                'round': $props.element.style.viewMode === 'round',
                            })
                                }, [
                                  _createCommentVNode(" <span>{{ tag.value }}</span>\n                                <span class=\"dt-element__tag-bg\" v-if=\"element.style.viewMode != 'default'\" v-bind:style=\"{\n                                    background: element.defaultColor !== true && tag.color !== null ? tag.color : null,\n                                }\"></span> "),
                                  _createElementVNode("span", null, _toDisplayString(tag.value), 1 /* TEXT */),
                                  _hoisted_17
                                ], 14 /* CLASS, STYLE, PROPS */, _hoisted_16))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  style: _normalizeStyle({
                                color: $props.element.defaultColor !== true && tag.color !== null ? tag.color : null,
                            }),
                                  class: _normalizeClass({
                                'square': $props.element.style.viewMode === 'square',
                                'round': $props.element.style.viewMode === 'round',
                            })
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(tag.value), 1 /* TEXT */),
                                  _createCommentVNode(" <span>{{ tag.value }}</span>\n                                <span class=\"dt-element__tag-bg\" v-if=\"element.style.viewMode != 'default'\" v-bind:style=\"{\n                                    background: element.defaultColor !== true && tag.color !== null ? tag.color : null,\n                                }\"></span> "),
                                  _hoisted_18
                                ], 6 /* CLASS, STYLE */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              : ($props.element['@type'] === 'text')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    class: _normalizeClass(["dt-element__wrapper dt-element__blockText", {'dt-element__blockText_decorationText': $props.element.style.viewMode === 'decorationText'}])
                  }, [
                    ($props.element.title)
                      ? (_openBlock(), _createElementBlock("strong", {
                          key: 0,
                          class: _normalizeClass(["dt-element__blockText-title", {'dt-element__blockText-title_icon': $props.element.showIcon === true}])
                        }, [
                          ($props.element.showIcon === true)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                ($props.element.icon === 'list')
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_26))
                                  : ($props.element.icon === 'marker')
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _hoisted_30))
                                    : ($props.element.icon === 'watch')
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_34))
                                      : ($props.element.icon === 'calendar')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_35, _hoisted_40))
                                        : ($props.element.icon === 'page')
                                          ? (_openBlock(), _createElementBlock("svg", _hoisted_41, _hoisted_45))
                                          : ($props.element.icon === 'human')
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_46, _hoisted_49))
                                            : ($props.element.icon === 'star')
                                              ? (_openBlock(), _createElementBlock("svg", _hoisted_50, _hoisted_52))
                                              : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(" " + _toDisplayString($props.element.title), 1 /* TEXT */)
                        ], 2 /* CLASS */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["block-textMin", {
                                                    'white': $props.element.style.viewMode === 'default' || !$props.element.style.viewMode,
                                                    'gray': $props.element.style.viewMode === 'grayColor'
                                                }])
                    }, [
                      _createElementVNode("p", null, _toDisplayString($props.element.value), 1 /* TEXT */)
                    ], 2 /* CLASS */)
                  ], 2 /* CLASS */))
                : ($props.element['@type'] === 'contact')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: _normalizeClass(["dt-element__wrapper dt-element__listContact", {'dt-element__listContact_decorationText': $props.element.style.viewMode === 'decorationText'}])
                    }, [
                      ($props.element.title)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_53, _toDisplayString($props.element.title), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_54, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.element.value, (itemContact) => {
                          return (_openBlock(), _createElementBlock("div", null, [
                            _createVNode(_component_icon_contact_short_block, {
                              type: itemContact.type,
                              value: itemContact.value,
                              "show-icon": $props.element.showIcons,
                              description: itemContact.description
                            }, null, 8 /* PROPS */, ["type", "value", "show-icon", "description"])
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ], 2 /* CLASS */))
                  : ($props.element['@type'] === 'map')
                    ? (_openBlock(), _createBlock(_component_map_element, {
                        key: 7,
                        element: $props.element
                      }, null, 8 /* PROPS */, ["element"]))
                    : ($props.element['@type'] === 'date-time')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          ($props.element.title)
                            ? (_openBlock(), _createElementBlock("strong", {
                                key: 0,
                                class: _normalizeClass(["dt-element__dateTime-title", {'dt-element__dateTime-title_icon': $props.element.style.viewMode === 'show_icons'}])
                              }, [
                                ($props.element.style.viewMode === 'show_icons')
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_56, _hoisted_61))
                                  : _createCommentVNode("v-if", true),
                                _createTextVNode(" " + _toDisplayString($props.element.title), 1 /* TEXT */)
                              ], 2 /* CLASS */))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("p", null, _toDisplayString($props.element.value), 1 /* TEXT */)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
    _hoisted_63
  ], 64 /* STABLE_FRAGMENT */))
}